<template>
  <div class="general-wrapper margin-side">
    <div :class="{'isLoading': getIsLoading, 'noDisplay': !getIsLoading}" class="overlay">
      <div class="spinner-align">
        <Icon name="spinner" scale="5" pulse class="icon-size"></Icon>
      </div>
    </div>
    <div v-if="!getIsLoading" class="scheduler-config-wrapper">
      <div class="icon-back-wrapper">
        <div class="icon-back" @click="back()"></div>
      </div>
      <div class="page-title">
        <div class="h2-text">
          Configure Scheduler
        </div>
        <div class="toggle-live toggle-on-off">
          <input type="checkbox" id="live" :class="{'checked': configurations.live}"/>
          <label for="live" @click="configurations.live = !configurations.live">Live</label>
          <div class="text-entry-title align-inline" :class="{'active': configurations.live}">Live</div>
        </div>
      </div>
      <b-button v-on:click="handleOpenSchedulerPreview()">Preview</b-button>
      <div class="row margin-top-40px">
        <div class="col-md-4 text-entry-field-wrapper">
          <div class="text-entry-title">Scheduler name</div>
          <input class="text-input" v-model="configurations.name"/>
        </div>
        <div class="col-md-8"></div>
      </div>
      <div class="row margin-top-40px">
        <div class="col-md-4 text-entry-field-wrapper">
          <div class="text-entry-title">Scheduler URL</div>
          <input class="text-input" v-model="configurations.schedulerUrl"/>
        </div>
        <div class="col-md-2 text-entry-field-wrapper">
          <div class="text-entry-title">URL Hyperlink Color</div>
          <input class="text-input" v-model="configurations.urlHyperlinkColor"/>
        </div>
        <div class="col-md-2 text-entry-field-wrapper">
          <div class="text-entry-title">Branded URL</div>
          <input class="text-input" v-model="configurations.brandedURL" v-validate="'required|url:require_protocol'" name="brandedURL"/>
          <div class="branded-url-error">
            <div v-if="errors.has('brandedURL')" class="alert-icon-red-error"></div>
            <div class="error-text-color">{{ errors.first('brandedURL') }}</div>
          </div>
        </div>
        <div class="col-md-4"></div>
      </div>
      <div class="row margin-top-40px">
        <div class="col-md-4 text-entry-field-wrapper">
          <div class="text-entry-title">Brand Name</div>
          <input class="text-input" v-model="configurations.brandName"/>
        </div>
        <div class="col-md-4 text-entry-field-wrapper">
          <div class="text-entry-title">Survey Biometric Result URL</div>
          <input class="text-input" v-model="configurations.surveyBiometricResultUrl"/>
        </div>
        <div class="col-md-4 text-entry-field-wrapper">
          <div class="text-entry-title">ShiftBoard Lead WorkGroup</div>
          <multiselect v-model="dropdowntitle"
                       :options="allWorkGroups"
                       placeholder="Choose WorkGroup"
                       label="name"
                       class="multiple-select-work-group"
                       :openDirection="'below'"
                       :multiple="false"
                       :close-on-select="true"
                       :hide-selected="true"
                       track-by="id"
                       :allow-empty="false"
                       :show-labels="false"
                       @select="dropdownItemClick"
                       :disabled="false">
          </multiselect>
          <div class="text-entry-title">ShiftBoard Screener WorkGroup</div>
          <multiselect v-model="screenerDropdowntitle"
                       :options="allWorkGroups"
                       placeholder="Choose Screener WorkGroup"
                       label="name"
                       class="multiple-select-work-group"
                       :openDirection="'below'"
                       :multiple="false"
                       :close-on-select="true"
                       :hide-selected="true"
                       track-by="id"
                       :allow-empty="false"
                       :show-labels="false"
                       @select="screenerDropdownItemClick"
                       :disabled="false">
          </multiselect>
          <div class="text-entry-title">ShiftBoard Phlebotomist WorkGroup</div>
          <multiselect v-model="phlebotomistDropdowntitle"
                       :options="allWorkGroups"
                       placeholder="Choose Phlebotomist WorkGroup"
                       label="name"
                       class="multiple-select-work-group"
                       :openDirection="'below'"
                       :multiple="false"
                       :close-on-select="true"
                       :hide-selected="true"
                       track-by="id"
                       :allow-empty="false"
                       :show-labels="false"
                       @select="phlebotomistDropdownItemClick"
                       :disabled="false">
          </multiselect>
        </div>
      </div>
      <div class="margin-top-24px toggle-limeade-sso-container">
        <div class="toggle-on-off">
          <input type="checkbox" id="without_limeade_login" :class="{'checked': configurations.allowWithoutLimeade}"/>
          <label for="without_limeade_login"
                 @click="configurations.allowWithoutLimeade = !configurations.allowWithoutLimeade">Toggle</label>
          <div class="text-entry-title align-inline"
               :class="{'active': configurations.allowWithoutLimeade}">Allow walk-in checkin
          </div>
        </div>
        <div class="toggle-on-off ">
          <input type="checkbox" id="allow_spouse" :class="{'checked': configurations.allowBookFluShot}"/>
          <label for="allow_spouse" @click="configurations.allowBookFluShot = !configurations.allowBookFluShot">Toggle</label>
          <div class="text-entry-title align-inline"
               :class="{'active': configurations.allowBookFluShot}">Allow flu shot appointment
          </div>
        </div>
        <div class="toggle-on-off">
          <input type="checkbox" id="is_display_zendesk" :class="{'checked': configurations.zendeskConfiguration}"/>
          <label for="is_display_zendesk" @click="configurations.zendeskConfiguration = !configurations.zendeskConfiguration">Toggle</label>
          <div class="text-entry-title align-inline"
               :class="{'active': configurations.zendeskConfiguration}">Allow ZenDesk
          </div>
        </div>
        <div class="toggle-on-off">
          <input type="checkbox" id="is_display_program_year" :class="{'checked': configurations.multipleScreeningsPerYear}"/>
          <label for="is_display_program_year" @click="configurations.multipleScreeningsPerYear = !configurations.multipleScreeningsPerYear">Toggle</label>
          <div class="text-entry-title align-inline"
               :class="{'active': configurations.multipleScreeningsPerYear}">Allow multiple screenings per year
          </div>
        </div>
        <div class="toggle-on-off">
          <input type="checkbox" id="flu_shot_only" :class="{'checked': configurations.fluShotOnly}"/>
          <label for="flu_shot_only" @click="configurations.fluShotOnly = !configurations.fluShotOnly">Toggle</label>
          <div class="text-entry-title align-inline"
               :class="{'active': configurations.fluShotOnly}">Allow flu shot only
          </div>
        </div>
      </div>
      <div class="row margin-top-40px">
        <div class="col-md-4">
          <div class="toggle-on-off">
            <input type="checkbox" id="allow_flu_shot" :class="{'checked': configurations.allowBookForSpouse}"/>
            <label for="allow_flu_shot" @click="configurations.allowBookForSpouse = !configurations.allowBookForSpouse">Toggle</label>
            <div class="text-entry-title align-inline" :class="{'active': configurations.allowBookForSpouse}">
              Spouse appointment
            </div>
          </div>
          <div class="text-entry-field-wrapper">
            <div class="text-entry-title margin-top-15px display-flex-end" :class="{'opacity-06': !configurations.allowBookForSpouse}">
              <div>Spouse Label</div>
              <div :class="{'noDisplay': !configurations.allowBookForSpouse}" class="display-space-between">
                <div v-if="errors.has('spouse')" class="alert-icon-red-error"></div>
                <div class="error-text-color">{{ errors.first('Spouse') }}</div>
              </div>
            </div>
            <input class="text-input" v-model="configurations.spouseLabel" :disabled="!configurations.allowBookForSpouse"
                   :class="{'opacity-06': !configurations.allowBookForSpouse}"  v-validate="'required'" name="Spouse"/>
          </div>
        </div>
        <div class="col-md-8"></div>
      </div>
      <div class="margin-top-40px toggle-limeade-sso-container">
      </div>
      <div class="row margin-top-40px">
        <div class="col-md-4 text-entry-field-wrapper">
          <div class="text-entry-title">Landing Page Top Text</div>
          <vue-ckeditor
            v-model="configurations.landingTopText"
            :config="config" ></vue-ckeditor>
          <!-- <textarea class="textarea-wrapper" v-model="configurations.landingTopText"></textarea> -->
        </div>
        <div class="col-md-4 text-entry-field-wrapper">
          <div class="text-entry-title">Landing Page Bottom Text</div>
          <vue-ckeditor
            v-model="configurations.landingBottomText"
            :config="config" ></vue-ckeditor>
          <!-- <textarea class="textarea-wrapper" v-model="configurations.landingBottomText"></textarea> -->
        </div>
        <div class="col-md-4 text-entry-field-wrapper">
          <div class="text-entry-title">Thank you page text</div>
          <vue-ckeditor
            v-model="configurations.landingThankYouText"
            :config="config" ></vue-ckeditor>
          <!-- <textarea class="textarea-wrapper" v-model="configurations.landingThankYouText"></textarea> -->
        </div>
      </div>
      <div class="row margin-top-40px">
        <div class="col-md-4">
          <div class="toggle-on-off">
            <input type="checkbox" id="hpsf" :class="{'checked': configurations.hpsf}"/>
            <label for="hpsf"
                   @click="configurations.hpsf = !configurations.hpsf">Toggle</label>
            <div class="hpsf-labcorp-htk align-inline padding-left-8px" :class="{'active': configurations.hpsf}">HPSF
            </div>
          </div>
          <div class="text-entry-field-wrapper">
            <div class="text-entry-title margin-top-15px display-flex-end" :class="{'opacity-06': !configurations.hpsf}">
              <div>HPSF URL</div>
              <div :class="{'noDisplay': !configurations.hpsf}" class="display-space-between">
                <div v-if="errors.has('hpsf')" class="alert-icon-red-error"></div>
                <div class="error-text-color">{{ errors.first('hpsf') }}</div>
              </div>
            </div>
            <input class="text-input" v-model="configurations.hpsfUrl" :disabled="!configurations.hpsf"
                   :class="{'opacity-06': !configurations.hpsf}"  v-validate="'required|url:require_protocol'" name="hpsf"/>
          </div>
        </div>
        <div class="col-md-4">
          <div class="toggle-on-off">
            <input type="checkbox" id="labcorp" :class="{'checked': configurations.labCorp}"/>
            <label for="labcorp"
                   @click="configurations.labCorp = !configurations.labCorp">Toggle</label>
            <div class="hpsf-labcorp-htk align-inline padding-left-8px" :class="{'active': configurations.labCorp}">
              Labcorp
            </div>
          </div>
          <div class="text-entry-field-wrapper">
            <div class="text-entry-title margin-top-15px display-flex-end" :class="{'opacity-06': !configurations.labCorp}">
              <div>Labcorp URL</div>
              <div :class="{'noDisplay': !configurations.labCorp}" class="display-space-between">
                <div v-if="errors.has('labcorp')" class="alert-icon-red-error"></div>
                <div class="error-text-color">{{ errors.first('labcorp') }}</div>
              </div>
            </div>
            <input class="text-input" v-model="configurations.labCorpUrl" :disabled="!configurations.labCorp"
                   :class="{'opacity-06': !configurations.labCorp}" v-validate="'required|url:require_protocol'" name="labcorp"/>
          </div>
        </div>
        <div class="col-md-4">
          <div class="toggle-on-off">
            <input type="checkbox" id="htk" :class="{'checked': configurations.htk}"/>
            <label for="htk"
                   @click="configurations.htk = !configurations.htk">Toggle</label>
            <div class="hpsf-labcorp-htk align-inline padding-left-8px" :class="{'active': configurations.htk}">HTK
            </div>
          </div>
          <div class="text-entry-field-wrapper">
            <div class="text-entry-title margin-top-15px display-flex-end" :class="{'opacity-06': !configurations.htk}">
              <div>HTK URL</div>
              <div :class="{'noDisplay': !configurations.htk}" class="display-space-between">
                <div v-if="errors.has('htk')" class="alert-icon-red-error"></div>
                <div class="error-text-color">{{ errors.first('htk') }}</div>
              </div>
            </div>
            <input class="text-input" v-model="configurations.htkUrl" :disabled="!configurations.htk"
                   :class="{'opacity-06': !configurations.htk}" v-validate="'required|url:require_protocol'" name="htk"/>
          </div>
        </div>
      </div>
      <div class="margin-top-40px">
        <div class="logo">Logo <span v-if="isUsedBingMap()">(Maximum size is 300KB)</span></div>
      </div>
      <div class="margin-top-15px" v-if="isUsedBingMap()">
        <div class="image-preview" v-if="imageData.length > 0">
          <img class="preview" :src="imageData">
        </div>
        <div class="upload-button-wrapper">
          <span class="upload-button-text">upload</span>
          <input type="file" name="imageFile" id="file" ref="logo" class="custom-file-input upload-avatar"
                 accept="image/*"
                 @change="previewImage">
        </div>
        <button class="ap-btn primary remove-button" v-if="imageData.length > 0" @click="removeImage()">remove</button>
      </div>
      <div class="margin-top-15px" v-if="!isUsedBingMap()">
        <div class="image-preview" v-if="configurations && configurations.logoUrl && configurations.logoUrl.length > 0">
          <img class="preview" :src="configurations.logoUrl">
        </div>
      </div>
      <div class="event-list">
        <div class="title">events</div>
        <div class="row list-event">
          <div class="col-md-4 list-event-item" v-for="event in eventSchedulerList" :key="event">
            <div class="event-name">{{event.eventName}}</div>
            <div class="toggle-on-off align-inline padding-left-19px">
              <input type="checkbox" :id="'event_' + event.id" :class="{'checked': event.isOnlineScheduler}"/>
              <label :for="'event_' + event.id"
                     @click="event.isOnlineScheduler = !event.isOnlineScheduler">Toggle</label>
              <div class="text-entry-title align-inline padding-left-3px"
                   :class="{'active': event.isOnlineScheduler}">Online scheduler
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="event-list">
        <div class="title">Participant Emails</div>
      </div>
      <div class="row margin-top-5px" v-if="configEmail.emailTags.length">
        <div class="col-md-6 text-entry-field-wrapper">
          <div class="email-head-text">Confirmation Email</div>
          <vue-ckeditor
            v-model="configurations.confirmationEmailTemplate.body"
            :config="configEmail"></vue-ckeditor>
        </div>
        <div class="col-md-6 text-entry-field-wrapper">
          <div class="email-head-text">Confirmation Email for Spouse</div>
          <vue-ckeditor
            v-model="configurations.confirmationSpouseEmailTemplate.body"
            :config="configEmail"></vue-ckeditor>
        </div>
      </div>
      <div class="row margin-top-5px" v-if="configEmail.emailTags.length">
        <div class="col-md-6 text-entry-field-wrapper">
          <div class="email-head-text">Cancellation Email To Participant</div>
          <vue-ckeditor
            v-model="configurations.cancellationEmailTemplate.body"
            :config="configEmail" ></vue-ckeditor>
        </div>
        <div class="col-md-6 text-entry-field-wrapper">
          <div class="email-head-text">Cancellation Email To Spouse</div>
          <vue-ckeditor
            v-model="configurations.cancellationSpouseEmailTemplate.body"
            :config="configEmail" ></vue-ckeditor>
        </div>
      </div>
      <div class="row margin-top-5px" v-if="configEmail.emailTags.length">
        <div class="col-md-6 text-entry-field-wrapper">
          <div class="email-head-text">Reminder Email To Participant</div>
          <vue-ckeditor
            v-model="configurations.reminderEmailTemplate.body"
            :config="configEmail" ></vue-ckeditor>
        </div>
        <div class="col-md-6 text-entry-field-wrapper">
          <div class="email-head-text">Reminder Email To Spouse</div>
          <vue-ckeditor
            v-model="configurations.reminderSpouseEmailTemplate.body"
            :config="configEmail" ></vue-ckeditor>
        </div>
      </div>
      <div class="row margin-top-5px" v-if="configEmail.emailTags.length">
        <div class="col-md-6 text-entry-field-wrapper">
          <div class="email-head-text">Biometric Survey Email</div>
          <vue-ckeditor
            v-model="configurations.biometricResultEmailTemplate.body"
            :config="configEmail" ></vue-ckeditor>
        </div>
      </div>
      <div class="margin-top-44px group-btn">
        <button class="ap-btn secondary" @click="back()">
          cancel
        </button>
        <button class="ap-btn primary" @click="saveConfigurations()" :disabled="isLoading" :class="{'opacity-04': isLoading}">Save</button>
      </div>
    </div>
    <PatientDetailModal/>
    <SchedulerPreview/>
    <!-- <ScrollTop/> -->
  </div>
</template>

<script>
  // import consts from '../../_consts';
  import Vue from 'vue';
  import {mapActions, mapGetters} from 'vuex';
  import VueSlider from 'vue-slider-component';
  import Multiselect from 'vue-multiselect';
  import Icon from 'vue-awesome/components/Icon';
  import PatientDetailModal from '../../components/modal/patient/PatientDetailModal';
  import SchedulerPreview from '../../components/modal/preview/SchedulerPreview';
  import ScrollTop from '../../components/utils/ScrollTop';
  import StaffManagement from '../../components/eventManagement/eventDetail/StaffManagement';
  import VueCkeditor from 'vue-ckeditor2';
  import VeeValidate from 'vee-validate';
  import constants from '../../_consts';
  import cssHelper from '../../utils/css-helper';

  Vue.use(VeeValidate);

  const dict = {
    custom: {
      hpsf: {
        required: 'The field is blank, please enter a URL',
        url: 'Please enter a valid URL'
      },
      labcorp: {
        required: 'The field is blank, please enter a URL',
        url: 'Please enter a valid URL'
      },
      htk: {
        required: 'The field is blank, please enter a URL',
        url: 'Please enter a valid URL'
      },
      brandedURL: {
        required: 'The field is blank, please enter a URL',
        url: 'Please enter a valid URL'
      }
    }
  };

  export default {
    name: 'event-detail-view',
    components: {
      VueSlider,
      Icon,
      PatientDetailModal,
      SchedulerPreview,
      ScrollTop,
      StaffManagement,
      VueCkeditor,
      Multiselect
    },
    props: {},
    data () {
      return {
        clientId: 0,
        dropdowntitle: {},
        screenerDropdowntitle: {},
        phlebotomistDropdowntitle: {},
        allWorkGroups: [],
        configurations: {
          allowBookFluShot: false,
          allowBookForSpouse: false,
          confirmationEmailTemplate: {
            body: ''
          },
          cancellationEmailTemplate: {
            body: ''
          },
          reminderEmailTemplate: {
            body: ''
          },
          reminderSpouseEmailTemplate: {
            body: ''
          },
          confirmationSpouseEmailTemplate: {
            body: ''
          },
          cancellationSpouseEmailTemplate: {
            body: ''
          },
          biometricResultEmailTemplate: {
            body: ''
          },
          spouseLabel: '',
          landingTopText: '',
          landingBottomText: '',
          landingThankYouText: ''
        },
        imageData: '',
        isLoading: false,
        eventSchedulerList: [],
        config: {
          toolbar: [
            { name: 'clipboard', items: [ 'Undo', 'Redo' ] },
            { name: 'styles', items: [ 'Format', 'Font', 'FontSize' ] },
            { name: 'basicstyles', items: [ 'Bold', 'Italic', 'Underline', 'Strike', 'RemoveFormat', 'CopyFormatting' ] },
            { name: 'colors', items: [ 'TextColor', 'BGColor' ] },
            { name: 'align', items: [ 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock' ] },
            { name: 'paragraph', items: [ 'NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote' ] },
            { name: 'tools', items: [ 'Maximize' ] }
          ],
          height: 300,
          toolbarCanCollapse: true,
          allowedContent: true,
          toolbarStartupExpanded: false
        },
        configEmail: {
          // config for editor of email fields
          toolbar: [
            { name: 'clipboard', items: [ 'Undo', 'Redo' ] },
            { name: 'styles', items: [ 'Format', 'Font', 'FontSize' ] },
            { name: 'basicstyles', items: [ 'Bold', 'Italic', 'Underline', 'Strike', 'RemoveFormat', 'CopyFormatting' ] },
            { name: 'colors', items: [ 'TextColor', 'BGColor' ] },
            { name: 'align', items: [ 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock' ] },
            { name: 'paragraph', items: [ 'NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote' ] },
            { name: 'tools', items: [ 'Maximize' ] },
            { name: 'Event Fields', items: ['eventTags'] },
            { name: 'document', items: ['Source'] }
          ],
          height: 300,
          fullPage: true, // allow content contains html/body/head tags
          autoGrow_onStartup: true,
          toolbarCanCollapse: true,
          allowedContent: true,
          toolbarStartupExpanded: true,
          extraPlugins: 'eventTags',
          emailTags: []
        }
      }
    },
    created () {
      // Get available tags to show on dropdown list of ckeditor
      this.actionGetEmailTags().then((response) => {
        this.configEmail.emailTags = [];
        for (let tag of response.tags) {
          if (!tag.useResetPassTemplate) {
            this.configEmail.emailTags.push(tag);
          }
        }
      });
    },
    methods: {
      handleOpenSchedulerPreview () {
        const config = JSON.parse(localStorage.getItem('SchedulerConfigurations'));
        this.$modal.show('schedulerPreviewModal', {
          allowBookFluShot: config.allowBookFluShot,
          allowBookForSpouse: config.allowBookForSpouse,
          spouseLabel: config.spouseLabel,
          landingTopText: config.landingTopText,
          landingBottomText: config.landingBottomText,
          landingThankYouText: config.landingThankYouText
        });
      },
      back () {
        this.$router.push({name: 'ManagerDashboard'});
      },
      previewFiles () {
        this.logo = this.$refs.logo.files;
      },
      isUsedBingMap () {
        return localStorage.getItem(constants.LOCAL_STORE.isBingMap) === 'true';
      },
      removeImage: function (e) {
        this.logo = null;
        this.imageData = '';
        this.configurations.logoFullUrl = null;
        this.configurations.logoUrl = null;
        this.configurations.logoThumbFullUrl = null;
      },
      previewImage: function (event) {
        // Reference to the DOM input element
        let input = event.target;
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
          if (input.files[0].size > 1020 * 300) {
            // 300KB
            this.$toast.success('File size must be less than 300Kb', '', {
              ...this.$toastOpt.optError
            });
            return;
          }
          // create a new FileReader to read this image and convert to base64 format
          let reader = new FileReader();
          // Define a callback function to run, when FileReader finishes its job
          reader.onload = (e) => {
            // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
            // Read image as base64 and set to imageData
            this.imageData = e.target.result;
          };
          // Start the reader job - read file as a data url (base64 format)
          reader.readAsDataURL(input.files[0]);
          this.logo = input.files[0];
        }
      },
      dropdownItemClick (item) {
        this.dropdownTitle = item;
        this.configurations.sbWorkGroupId = item.id;
      },

      screenerDropdownItemClick (item) {
        this.screenerDropdownTitle = item;
        this.configurations.sbScreenerWorkGroupId = item.id;
      },

      phlebotomistDropdownItemClick (item) {
        this.phlebotomistDropdownTitle = item;
        this.configurations.sbPhlebotomistWorkGroupId = item.id;
      },
      saveConfigurations: async function () {
        if (this.isLoading) {
          return;
        }

        // start - check if HPSF, labcorp or HTK is on, text box must not be empty
        let isValid = false;
        await this.$validator.validate().then(result => {
          isValid = result;
        });
        if (this.errors.items.length > 0) {
          if (this.errors.items[0].rule === 'required') {
            this.$toast.success('The field is blank, please enter a URL', '', {
              ...this.$toastOpt.optError
            });
          } else {
            this.$toast.success('Please enter a valid URL', '', {
              ...this.$toastOpt.optError
            });
          }
        }
        if (!isValid) {
          return;
        }
        // End

        this.$swal({
          title: "<div class='ems_alert_title'>Configure Scheduler</div>",
          html: "<div class='ems_alert_des'>Are you sure to save these configurations?</div>",
          confirmButtonColor: '#0080A5',
          confirmButtonText: 'SAVE',
          showCancelButton: true,
          cancelButtonColor: '#fff',
          cancelButtonText: 'CANCEL',
          buttonsStyling: true,
          reverseButtons: true,
          confirmButtonClass: 'ems_alert_confirm open',
          cancelButtonClass: 'ems_alert_cancel',
          customClass: 'ems_confirm',
          allowOutsideClick: false,
          allowEscapeKey: false,
          width: 605
        }).then((result) => {
          if (result.value) {
            this.isLoading = true;
            if (!this.logo || this.isUsedBingMap()) {
              this.actionSaveConfigurations(this.configurations).then((responseSaveConfigs) => {
                if (!responseSaveConfigs.message) {
                  this.configurations = responseSaveConfigs.configurations;
                  this.$toast.success('Saved configurations!', '', {
                    ...this.$toastOpt.optSuccess
                  });
                  this.updateClientEventSchedulerStatus();
                } else {
                  this.$toast.success(responseSaveConfigs.message, '', {
                    ...this.$toastOpt.optError
                  });
                }
                this.isLoading = false;
              });
            } else {
              this.actionUploadLogo({clientId: this.clientId, imageFile: this.logo}).then((response) => {
                if (!response.message) {
                  this.actionGetClientSchedulerConfig(this.clientId).then((newConfigs) => {
                    if (!newConfigs.message) {
                      this.configurations.logoUrl = newConfigs.configurations.logoUrl;
                      this.configurations.logoThumbFullUrl = newConfigs.configurations.logoThumbFullUrl;
                      this.configurations.logoFullUrl = newConfigs.configurations.logoFullUrl;
                      this.actionSaveConfigurations(this.configurations).then((responseSaveConfigs) => {
                        if (!responseSaveConfigs.message) {
                          this.configurations = newConfigs.configurations;
                          this.$toast.success('Saved configurations!', '', {
                            ...this.$toastOpt.optSuccess
                          });
                          this.updateClientEventSchedulerStatus();
                        } else {
                          this.$toast.success(responseSaveConfigs.message, '', {
                            ...this.$toastOpt.optError
                          });
                        }
                        this.isLoading = false;
                      });
                    } else {
                      this.$toast.success(newConfigs.message, '', {
                        ...this.$toastOpt.optError
                      });
                      this.isLoading = false;
                    }
                  });
                } else {
                  this.$toast.success(response.message, '', {
                    ...this.$toastOpt.optError
                  });
                  this.isLoading = false;
                }
              });
            }
            localStorage.setItem('SchedulerConfigurations', JSON.stringify(this.configurations));
            cssHelper.customColorForUI();
          }
        });
      },
      updateClientEventSchedulerStatus () {
        this.actionUpdateClientEventSchedulerStatus({
          clientId: this.clientId,
          events: this.eventSchedulerList
        }).then((response) => {
          if (!response.message) {
            this.eventSchedulerList = response.events;
          } else {
            this.$toast.success(response.message, '', {
              ...this.$toastOpt.optError
            });
          }
        });
      },
      ...mapActions({
        actionGetClientSchedulerConfig: 'ACTION_GET_CLIENT_SCHEDULER_CONFIG',
        actionGetEmailTags: 'ACTION_GET_EMAIL_TAGS',
        actionSaveConfigurations: 'ACTION_SAVE_CONFIGURATIONS',
        actionUploadLogo: 'ACTION_UPLOAD_LOGO',
        getClientEventSchedulerStatus: 'ACTION_GET_CLIENT_EVENT_SCHEDULER_STATUS',
        actionUpdateClientEventSchedulerStatus: 'ACTION_UPDATE_CLIENT_EVENT_SCHEDULER_STATUS'
      })
    },
    computed: {
      ...mapGetters({
        getIsLoading: 'GETTER_IS_LOADING_MODAL'
      })
    },
    mounted () {
      this.$validator.localize('en', dict); // This is used to overwrite the default error message
      this.clientId = this.$route.params.clientId;
      this.actionGetClientSchedulerConfig(this.clientId).then((response) => {
        if (!response.errors) {
          this.configurations = response.configurations || {};
          localStorage.setItem('SchedulerConfigurations', JSON.stringify(this.configurations));
          this.imageData = this.configurations.logoFullUrl ? process.env.SOF_API_SERVER_HOST + '/' + this.configurations.logoFullUrl : '';
          // call api to get event scheduler list
          this.getClientEventSchedulerStatus(this.clientId).then((response) => {
            this.eventSchedulerList = response.events || [];
          });
          this.allWorkGroups = response.sbWorkGroupDtos;
          this.dropdowntitle = response.sbWorkGroupDtos.find(x => x.id === this.configurations.sbWorkGroupId);
          this.screenerDropdowntitle = response.sbWorkGroupDtos.find(x => x.id === this.configurations.sbScreenerWorkGroupId);
          this.phlebotomistDropdowntitle = response.sbWorkGroupDtos.find(x => x.id === this.configurations.sbPhlebotomistWorkGroupId);
        } else {
          this.$toast.success(response.errors, '', {
            ...this.$toastOpt.optError
          });
        }
      });
    }
  };
</script>
<style lang="less" scoped>
  @import '../../styles/variables.less';

  .general-wrapper {
    background-color: @white;
    font-family: @font-family-main;

    .scheduler-config-wrapper {
      background-color: @white;
      .icon-back-wrapper{
        padding-top: 24px;

        .icon-back {
          width: 27px;
          height: 27px;
          color: @grey-3;
          background-color: @grey-3;
          -webkit-mask: url('../../../static/img/backward-line.svg') no-repeat center;
          mask: url('../../../static/img/backward-line.svg') no-repeat center;
          background: url('../../../static/img/backward-line-grey.svg');

          &:hover{
            cursor: pointer;
          }
        }
      }

      .page-title{
        margin-top: 12px;
        display: flex;

        .toggle-live{
          margin-left: 24px;
        }
      }

      .text-entry-field-wrapper{
        .text-entry-title{
          color: #424242;
          font-size: 12px;
          line-height: 28px;
        }

        .text-input {
          height: 32px;
          width: 100%;
          border: 1px solid #B9B9B9;
          border-radius: 4px;
        }
      }

      .toggle-limeade-sso-container{
        .toggle-on-off{
          display: inline-block;
          margin-right: 24px;
          margin-top: 16px;
          .text-entry-title{

          }
        }
      }

      .scheduler-config {
        color: @black-3;
        font-family: @font-family-main;
        font-size: 24px;
        font-weight: 600;
        letter-spacing: 0.2px;
        line-height: 32px;
      }
      .align-inline {
        display: inline-block;
      }

      .textarea-wrapper {
        height: 140px;
        border: 1px solid #B9B9B9;
        border-radius: 4px;
      }

      .logo {
        color: #626262;
        font-family: @font-family-main;
        font-size: 12px;
        line-height: 16px;
      }

      .remove-button{
        padding: 7px 24px;
      }
      .upload-button-wrapper {
        display: inline-block;
        background-color: #00A4D6;
        border-radius: 4px;
        position: relative;
        padding: 6px 24px;

        .upload-avatar {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 999;
          max-height: 100%;
        }

        .custom-file-input{
          width: 114px;
          min-width: 0;
          &:hover {
            cursor: pointer;
          }
        }
        .upload-button-text {
          color: #FFFFFF;
          text-transform: uppercase;
          font-size: 16px;
          font-weight: 600;
        }

        input:invalid {
          border-color: #FF3400;
        }
      }

      .hpsf-labcorp-htk {
        color: #626262;
        font-family: @font-family-main;
        font-size: 12px;
        line-height: 16px;
      }
      .align-right-buttons {
        text-align: right;
      }
      .cancel-button {
        height: 32px;
        border: 1px solid #00A4D6;
        border-radius: 4px;
        .label {
          color: #00A4D6;
          font-family: @font-family-main;
          font-size: 16px;
          font-weight: 600;
          letter-spacing: 0.1px;
          line-height: 20px;
          cursor: pointer;
          position: relative;
          top: 50%;
          left: 50%;
          float: left;
          transform: translate(-50%, -50%);
          text-transform: uppercase;
        }
      }
      .save-button {
        height: 32px;
        background-color: #00A4D6;
        border-radius: 4px;
        .label {
          color: @white;
          font-family: @font-family-main;
          font-size: 16px;
          font-weight: 600;
          letter-spacing: 0.1px;
          line-height: 20px;
          cursor: pointer;
          position: relative;
          top: 50%;
          left: 50%;
          float: left;
          transform: translate(-50%, -50%);
          text-transform: uppercase;
        }
      }
      .toggle-on-off {
        .text-entry-title{
          margin-left: 8px;
          color: #626262;
          font-size: 12px;
        }

        input[type=checkbox] {
          height: 0;
          width: 0;
          visibility: hidden;
        }

        label {
          float: left;
          cursor: pointer;
          text-indent: -9999px;
          width: 32px;
          height: 18px;
          background: #fff;
          border-radius: 15.5px;
          position: relative;
          top: 1.5px;
          left: 0;
          border: 1.5px solid rgba(0, 0, 0, 0.1);
          margin-bottom: 0;
        }

        label:after {
          content: '';
          position: absolute;
          top: -0.5px;
          left: -0.5px;
          width: 16px;
          height: 16px;
          background: #fff;
          border-radius: 15.5px;
          -webkit-transition: 0.3s;
          transition: 0.3s;
          border: 0.5px solid rgba(0, 0, 0, 0.1);

        }

        input.checked + label {
          background: #00A4D6;
          border: 1.5px solid #00A4D6;
          // border: none;
        }

        input.checked + label:after {
          // top: -0.5px;
          left: calc(100% - 0px);
          transform: translateX(-100%);
          box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);
        }

        label:active:after {
          width: 15px;
        }
        .active {
          color: #00A4D6;
          font-size: 12px;
          font-weight: bold;
          line-height: 16px;
        }
      }
    }
    .event-list {
      .title {
        height: 28px;
        color: #444444;
        font-family: "Open Sans", sans-serif;
        font-size: 20px;
        font-weight: bold;
        letter-spacing: 0.17px;
        line-height: 28px;
        text-transform: capitalize;
        margin-top: 40px;
      }

      .list-event {
        height: auto;
        border: 1px solid #B9B9B9;
        border-radius: 4px;
        margin: 16px 0 0 0;
        padding: 16px;
        // overflow-y: scroll;
        .list-event-item {
          line-height: 22px;
          padding: 5px 0;
          .event-name {
            color: #424242;
            font-family: "Open Sans", sans-serif;
            font-size: 16px;
            line-height: 24px;
            float: left;
            max-width: 220px;
          }
        }
      }
    }

    .group-btn{
      display: flex;
      justify-content: flex-end;
      padding-bottom: 40px;

      .ap-btn{
        font-size: 14px;
        padding: 6px 24px;
        & + .ap-btn {
          margin-left: 16px;
        }
      }
    }
  }

  .isLoading {
    display: block;
    text-align: center;
    color: #606060;
    height: 100%;
  }

  .noDisplay {
    display: none!important;
  }

  .overlay {
    position: relative;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
    cursor: pointer;
  }

  .spinner-align {
    position: absolute;
    top: 50%;
    left: 50%;
    font-size: 50px;
    color: white;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
  }

  .image-preview {
    width: 350px;
    height: auto;
    margin-bottom: 15px;
    .preview {
      max-width: 100%;
      max-height: 200px;
    }
  }

  .loading-btn {
    width: 15px;
  }

  .email-head-text {
    color: #424242;
    font-family: @font-family-main;
    font-weight: bold;
    font-size: 16px;
    line-height: 32px;
    margin-top: 20px;
  }

  .alert-icon-red-error {
    width: 24px;
    height: 24px;
    color: @white;
    background-color: @white;
    background: url('../../../static/img/icon-field-error-red-boder.svg') no-repeat center;
  }

  .display-space-between {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
  }
  .display-flex-end{
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }

  .error-text-color {
    color: #FF3400;
    font-family: "Open Sans",serif;
    font-size: 12px;
    line-height: 16px;
    margin-left: 8px;
  }

  .branded-url-error {
    display: flex;
    align-items: center;
  }

  .sf-program-id-error {
    display: flex;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// SchedulerConfiguration.vue?66f0abf4